/**
 * @fileOverview This file contains the implementation of the Maintenance Agenda module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { GlobalVariables } from '../globalVar';
import customAxios from '../utils/customAxios';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import AgendaToolbar from '../components/MaintenanceAgenda/AgendaToolbar';
import AgendaCalendar from '../components/MaintenanceAgenda/AgendaCalendar';
import { Helmet } from 'react-helmet';
//#endregion

const MaintenanceAgenda = () => {
  const {} = useTranslationHook();

  const [assets, setAssets] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState([]);

  let endpoint = `${GlobalVariables.getURL()}testAsset`;

  async function getAssets() {
    try {
      console.log('Aqui');
      const response = await customAxios.get(endpoint);
      setAssets(response.data.data);
      console.log('Assets: ', response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getAssets();
  }, []);

  return (
    <Box height={'100%'} width={'100%'} p={'20px'}>
      <Helmet>
        <title>Agenda | DABI</title>
      </Helmet>
      <AgendaToolbar
        assets={assets}
        selectedAssets={selectedAssets}
        setSelectedAssets={setSelectedAssets}
      />

      <Box width={'100%'} height={'90%'} padding={2}>
        <AgendaCalendar assets={assets} selectedAssets={selectedAssets} />
      </Box>
    </Box>
  );
};

export default MaintenanceAgenda;
